<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrapper">
        <ServerOrder :currServs="currServers" />
      </div>
    </div>
  </div>
</template>
<script>
import ServerOrder from '../../components/serverOrder/mobile.vue';
export default {
  components: {
    ServerOrder,
  },
  data() {
    return {
      title: '服务器购买页面',
      currServers: [],
    };
  },
  created() {
    if (this.$route.params.type === 'renew') {
      this.currServers = JSON.parse(localStorage.getItem('renewItems') || '[]');
    }
    console.log('buy.vue created---', this.currServers);
  },
};
</script>
<style src="../../style/common-m.scss" lang="scss" scoped></style>
